
import { defineComponent } from "@vue/runtime-core";
import Card from "../Card.vue";
export default defineComponent({
	name: "CourseListItemSkeleton",
	components: { Card },
});
